/* eslint-disable import/no-extraneous-dependencies */
import alertReducer from '@core/store/alertReducer';
import loadingReducer from '@core/store/loadingReducer';
import authReducer from '@pages/auth/store/reducer';
import loanSimulatorWorkflowReducer from '@pages/loan-simulator/store/workflowSlice';
import workflowListReducer from '@pages/rules/store/workflowListReducer';
import workflowReducer from '@pages/workflow/store/workflowSlice';
import ruleDetailWorkflowReducer from '@pages/rule-detail/store/workflowStore';
import inputNodeReducer from '@pages/rule-detail/nodeConfig/inputNodeConfig/store/inputNodeReducer';
import casesReducer from '@pages/cases/store/casesSlice';
import {combineReducers, configureStore, Action} from '@reduxjs/toolkit';
import {persistReducer, persistStore} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Use localStorage instead of sessionStorage

const appReducer = combineReducers({
  auth: authReducer,
  loader: loadingReducer,
  alert: alertReducer,
  loanSimulatorWorkflow: loanSimulatorWorkflowReducer,
  workflowList: workflowListReducer,
  workflow: workflowReducer,
  ruleDetailWorkflow: ruleDetailWorkflowReducer,
  inputNode: inputNodeReducer,
  cases: casesReducer,
});

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: Action
) => {
  if (action.type === 'RESET') {
    storage.removeItem('persist:root'); // Remove persisted state
    return appReducer(undefined, action); // Reset all reducers
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: 'root',
  storage, // Now using localStorage
  blacklist: ['loader', 'alert'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const {dispatch} = store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);

export default store;
